export enum DIALOG_SIZE {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}